const toggleInputs = document.querySelectorAll('[data-js-header-main-navigation-sub-items-toggle]');
const mainNavigationItems = document.querySelectorAll('[data-js-header-main-navigation-item]');
const menuOpenButton = document.querySelector('[data-js-header-menu-open]');
const menuCloseButton = document.querySelector('[data-js-header-menu-close]');

const HTML_CLASSES = {
    hiddenMenuItem: 'header__main-navigation-item_hidden-menu-item',
    activeMenuItem: 'header__main-navigation-item_active-menu-item',
    menuOpened: 'header--menu_opened',
    bodyHeaderMenuOpened: 'body_header-menu_opened',
};

menuOpenButton?.addEventListener('click', () => {
    mainNavigationItems.forEach((item) => {
        item.classList.remove(HTML_CLASSES.hiddenMenuItem);
        item.classList.remove(HTML_CLASSES.activeMenuItem);
    });

    toggleInputs.forEach((input: HTMLInputElement) => {
        // eslint-disable-next-line no-param-reassign
        input.checked = false;
    });

    document.querySelector('[data-js="header"]')?.classList.add(HTML_CLASSES.menuOpened);
    document.querySelector('body')?.classList.add(HTML_CLASSES.bodyHeaderMenuOpened);
});

menuCloseButton?.addEventListener('click', () => {
    document.querySelector('[data-js="header"]')?.classList.remove(HTML_CLASSES.menuOpened);
    document.querySelector('body')?.classList.remove(HTML_CLASSES.bodyHeaderMenuOpened);
});

if (toggleInputs && toggleInputs.length > 0) {
    toggleInputs.forEach((input) => {
        input.addEventListener('change', (event) => {
            const target = event.target as HTMLElement;
            const parentElement = target?.parentElement as HTMLElement;
            const toHide = parentElement.classList.contains(HTML_CLASSES.activeMenuItem);

            mainNavigationItems.forEach((item) => {
                item.classList.remove(HTML_CLASSES.activeMenuItem);
                item.classList.add(HTML_CLASSES.hiddenMenuItem);
            });

            if (toHide) {
                parentElement.classList.remove(HTML_CLASSES.hiddenMenuItem);
                parentElement.classList.remove(HTML_CLASSES.activeMenuItem);

                mainNavigationItems.forEach((item) => {
                    item.classList.remove(HTML_CLASSES.hiddenMenuItem);
                });
            } else {
                parentElement.classList.remove(HTML_CLASSES.hiddenMenuItem);
                parentElement.classList.add(HTML_CLASSES.activeMenuItem);
            }
        });
    });
}

export {};
